<template>
	<div>
		<el-divider>{{ bbsname }}字段管理</el-divider>
		<el-button type="warning" size="mini" icon="el-icon-edit" @click="addAttr('')">添加字段</el-button>
		<el-button-group>
			<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
			<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
		</el-button-group>
		<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteAttr">删除</el-button>
		<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getBbsAttrList">刷新</el-button>
		<el-dropdown trigger="click">
			<el-button type="success" icon="el-icon-setting" size="mini">
				设置
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(items, index) in setList" :key="index">
					<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
						<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item
								icon="el-icon-caret-right"
								v-for="(item, index) in items.seconds"
								:key="index"
								:command="{ setParam: items.paramValue, setParamVal: item.val }"
							>
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-table
			:data="attrList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="baid"
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@selection-change="selectChange"
			tooltip-effect="dark"
			ref="multipleTable"
		>
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="baid" label="序号" width="80" sortable></el-table-column>
			<el-table-column prop="pid" label="排序" width="80" sortable></el-table-column>
			<el-table-column prop="typename" label="字段名称"></el-table-column>
			<el-table-column prop="attrname" label="字段代号"></el-table-column>
			<el-table-column prop="inputtype" label="字段类型"></el-table-column>
			<el-table-column prop="isvalidate" label="字段验证">
				<template slot-scope="scope">
					<i :class="scope.row.isvalidate ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
				</template>
			</el-table-column>
			<el-table-column prop="issearch" label="加入搜索条件">
				<template slot-scope="scope">
					<i :class="scope.row.issearch ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
				</template>
			</el-table-column>
			<el-table-column prop="isclass" label="启用状态">
				<template slot-scope="scope">
					<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button type="warning" size="mini" @click="addAttr(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="bbsname + '字段管理'" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
			<el-form class="text-left" ref="attrForm" :rules="rules" :model="attrScope">
				<template v-if="!attrScope.baid">
					<el-form-item label="字段名称" :label-width="formLabelWidth" prop="typename">
						<el-input v-model="attrScope.typename" autocomplete="off" placeholder="请输入字段名称,长度2-50个字符"></el-input>
					</el-form-item>
					<el-form-item label="添加类型" :label-width="formLabelWidth">
						<el-radio v-model="attrScope.lockin" :label="0">自定义添加</el-radio>
						<el-radio v-model="attrScope.lockin" :label="1">默认字段添加</el-radio>
					</el-form-item>
					<template v-if="!attrScope.lockin">
						<el-form-item label="字段代号" :label-width="formLabelWidth" prop="attrname">
							<el-input v-model="attrScope.attrname" autocomplete="off" placeholder="请输入字段代号,长度2-50位小写英文或下划线组成,一旦填写不可修改"></el-input>
						</el-form-item>
						<el-form-item label="字段类型" :label-width="formLabelWidth" prop="inputtype">
							<el-select v-model="attrScope.inputtype" placeholder="请选择">
								<el-option v-for="item in typeList" :key="item.ty_label" :label="item.ty_label" :value="item.ty_val"></el-option>
							</el-select>
						</el-form-item>
					</template>
					<el-form-item v-else label="关联默认字段" :label-width="formLabelWidth" prop="attrname">
						<el-select v-model="attrScope.attrname" placeholder="请选择" @change="attrnameChange">
							<el-option v-for="item in defaultAttrList" :key="item.attrname" :label="item.typename" :value="item.attrname"></el-option>
						</el-select>
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item v-if="attrScope.lockin" label="关联默认字段" :label-width="formLabelWidth">{{ attrScope.attrname }}</el-form-item>
					<el-form-item label="字段代号" :label-width="formLabelWidth">{{ attrScope.attrname }}</el-form-item>
					<el-form-item label="字段类型" :label-width="formLabelWidth">{{ attrScope.inputtype }}</el-form-item>
					<el-form-item label="字段名称" :label-width="formLabelWidth" prop="typename">
						<el-input v-model="attrScope.typename" autocomplete="off" placeholder="请输入字段名称,长度2-50个字符"></el-input>
					</el-form-item>
				</template>
				<el-form-item label="提示文字" :label-width="formLabelWidth" prop="typeremark">
					<el-input v-model="attrScope.typeremark" autocomplete="off" placeholder="请输入提示文字,2-50个字符"></el-input>
				</el-form-item>
				<el-form-item label="默认值" :label-width="formLabelWidth">
					<el-input
						type="textarea"
						v-model="attrScope.attrvalue"
						:rows="4"
						autocomplete="off"
						:autosize="{ minRows: 4, maxRows: 8 }"
						placeholder="请填写默认值，如果字段为下拉、复合选项关联输入框、单选或多选，请每个默认值回车输入"
					></el-input>
				</el-form-item>
				<el-form-item label="文本框高度" :label-width="formLabelWidth" prop="attrrow">
					<el-input v-model="attrScope.attrrow" autocomplete="off" placeholder="提示：文本框高度只在多行文件、编辑器、HTML文本中有效！">
						<template slot="append">
							px
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="字段验证" :label-width="formLabelWidth">
					<el-radio v-model="attrScope.isvalidate" :label="1">开启验证</el-radio>
					<el-radio v-model="attrScope.isvalidate" :label="0">关闭验证</el-radio>
				</el-form-item>
				<template v-if="attrScope.isvalidate == 1">
					<el-form-item label="验证规则" :label-width="formLabelWidth">
						<el-select v-model="attrScope.validatetext" placeholder="请选择">
							<el-option v-for="item in validateList" :key="item.va_label" :label="item.va_label" :value="item.va_val"></el-option>
						</el-select>
						<el-input v-model="attrScope.validatetext" autocomplete="off" placeholder="请输入验证正则表达式"></el-input>
					</el-form-item>
					<el-form-item label="验证错误提示语" :label-width="formLabelWidth">
						<el-input v-model="attrScope.validate_str" autocomplete="off" placeholder="请输入验证错误提示语,长度2-50个字符"></el-input>
					</el-form-item>
				</template>
				<el-form-item label="加入搜索条件" :label-width="formLabelWidth">
					<el-radio v-model="attrScope.issearch" :label="1">开启</el-radio>
					<el-radio v-model="attrScope.issearch" :label="0">关闭</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Sortable from 'sortablejs';
export default {
	name: '',
	data() {
		return {
			bid: '',
			bbsname: '',
			attrList: [],
			selectedAttrIds: [],
			setList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setParam: '',
			setParamVal: '',
			dialogVisible: false,
			attrScope: {
				bid:'',//所属模型id
				typename: '', //字段名
				attrname: '', //字段代号
				inputtype: '', //字段类型
				isvalidate: 0, //是否开启正则验证，默认关闭
				validatetext: '', //验证正则
				validate_str: '', //验证错误提示语
				typeremark: '', //提示文字
				attrvalue: '', //默认值
				attrrow: '', //文本高度
				issearch: 0,//加入搜索条件,默认关闭
				lockin:1//1默认0自定义字段添加
			},
			rules: {
				typename: [{ required: true, message: '请输入字段名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				attrname: [{ required: true, message: '请输入字段代号', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				inputtype: [{ required: true, message: '请选择字段类型', trigger: 'blur' }]
			},
			formLabelWidth: '120px',
			defaultAttrList: [
				{
					typename: '作者（author）',
					attrname: 'author',
					typeremark: '请输入作者，长度2至20位的任意字符',
					inputtype: 'string',
					attrvalue: '',
					attrrow: '5'
				},
				{
					typename: '来源（source）',
					attrname: 'source',
					typeremark: '请输入来源，长度2至20位的任意字符',
					inputtype: 'selectinput',
					attrvalue: '',
					attrrow: '5'
				},
				{
					typename: '代表图片（pic）',
					attrname: 'pic',
					typeremark: '请选择当前代表图片',
					inputtype: 'img',
					attrvalue: '',
					attrrow: '5'
				},
				{
					typename: '简介（summary）',
					attrname: 'summary',
					typeremark: '请输入简介，长度2至200位的任意字符',
					inputtype: 'htmltext',
					attrvalue: '',
					attrrow: '80'
				},
				{
					typename: '内容（content）',
					attrname: 'content',
					typeremark: '请输入内容，长度2至2000位的任意字符',
					inputtype: 'editor',
					attrvalue: '',
					attrrow: '400'
				}
			],
			validateList: [
				{
					va_label: '长度限制',
					va_val: '^.{2,200}$'
				},
				{
					va_label: '数字',
					va_val: '^[0-9.-]+$'
				},
				{
					va_label: '整数',
					va_val: '^[0-9-]+$'
				},
				{
					va_label: '小写字母',
					va_val: '^[a-z]+$'
				},
				{
					va_label: '数字+字母',
					va_val: '^[0-9a-z]+$'
				},
				{
					va_label: 'Email',
					va_val: '^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$'
				},
				{
					va_label: 'QQ',
					va_val: '^[0-9]{5,20}$'
				},
				{
					va_label: '超链接',
					va_val: '^http:\\/\\//$'
				},
				{
					va_label: '手机号码',
					va_val: '^(1)[0-9]{10}$'
				},
				{
					va_label: '电话号码',
					va_val: '^[0-9-]{6,13}$'
				},
				{
					va_label: '邮政编码',
					va_val: '^[0-9]{6}$'
				}
			],
			typeList: [
				{
					ty_label: '单行文本',
					ty_val: 'string'
				},
				{
					ty_label: '多行文本',
					ty_val: 'htmltext'
				},
				{
					ty_label: '编辑器',
					ty_val: 'editor'
				},
				{
					ty_label: 'HTML文本',
					ty_val: 'htmltext'
				},
				{
					ty_label: '整数类型',
					ty_val: 'int'
				},
				{
					ty_label: '小数类型',
					ty_val: 'decimal'
				},
				{
					ty_label: '日期类型',
					ty_val: 'date'
				},
				{
					ty_label: '时间类型',
					ty_val: 'time'
				},
				{
					ty_label: '日期时间类型',
					ty_val: 'datetime'
				},
				{
					ty_label: '图片附件',
					ty_val: 'img'
				},
				{
					ty_label: '文件附件',
					ty_val: 'doc'
				},
				{
					ty_label: '视频附件',
					ty_val: 'video'
				},
				{
					ty_label: '下拉框',
					ty_val: 'selectinput'
				},
				{
					ty_label: '单选框',
					ty_val: 'redioinput'
				},
				{
					ty_label: '复选框',
					ty_val: 'checkboxinput'
				},
				{
					ty_label: '复合选项关联输入框',
					ty_val: 'complexinput'
				},
				{
					ty_label: '价格',
					ty_val: 'decimalstring'
				}
			]
		};
	},
	mounted() {
		this.bid = this.$route.query.bid;
		this.bbsname = this.$route.query.bbsname;
		console.log(this.bid);
		this.getBbsAttrList();
	},
	methods: {
		getBbsAttrList() {
			this.$axios({
				url: this.HOST + '/admin.module/bbsAttrList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					bid: this.bid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.attrList = res.data.list;
						this.defaultAttrList = res.data.defaultAttrList;
						let that = this;
						this.rowDrop(that); // 行拖拽排序
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].baid);
			}
			this.selectedAttrIds = arr;
			console.log(this.selectedAttrIds);
		},
		// 全选
		selectAll() {
			this.attrList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedAttrIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.attrList.map(item => {
				if (this.selectedAttrIds.indexOf(item.baid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.baid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedAttrIds = diff;
			console.log(this.selectedAttrIds);
		},
		// 操作
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setAttrClass();
		},
		deleteAttr() {
			if (!this.selectedAttrIds.length) {
				this.$message.error('尚未选中任何字段！');
				return false;
			}
			this.$confirm('是否要删除所选字段？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/deleteAttr',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							attrIds: this.selectedAttrIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getBbsAttrList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		setAttrClass() {
			if (!this.selectedAttrIds.length) {
				this.$message.error('尚未选中任何字段！');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.module/setAttrClass',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					attrIds: this.selectedAttrIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.getBbsAttrList();
					}
				})
				.catch(err => {});
		},
		// 行拖拽排序
		rowDrop(that) {
			// 此时找到的元素是要拖拽元素的父容器
			const tbody = document.querySelector('.el-table__body-wrapper tbody');
			const _this = that;
			Sortable.create(tbody, {
				// 指定父元素下可被拖拽的子元素
				draggable: '.el-table__row',
				onEnd({ newIndex, oldIndex }) {
					const currRow = _this.attrList.splice(oldIndex, 1)[0];
					_this.attrList.splice(newIndex, 0, currRow);
					console.log('行拖拽结果', 'newIndex:' + newIndex, 'oldIndex:' + oldIndex, 'currRow:', currRow);
					_this.attrList.map((item, index) => {
						item.pid = index;
					});
					// 调用后台拖拽排序接口
					if(newIndex != oldIndex){
						_this._updateMoveData();
					}
				}
			});
		},
		// 拖拽排序接口
		async _updateMoveData() {
			this.$axios({
				url: this.HOST + '/admin.module/updateAttrSort',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					attrList: this.attrList
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log('已成功重排序');
					}
				})
				.catch(err => {});
		},
		attrnameChange(val) {
			this.defaultAttrList.map(item => {
				if (item.attrname == val) {
					console.log(item);
					this.attrScope.typeremark = item.typeremark;
					this.attrScope.attrrow = item.attrrow;
					this.attrScope.inputtype = item.inputtype;
				}
			});
		},
		addAttr(scope) {
			if (!scope) {
				this.attrScope = {
					bid:this.bid,
					typename: '', //字段名
					attrname: '', //字段代号
					inputtype: '', //字段类型
					isvalidate: 0, //是否开启正则验证，默认关闭
					validatetext: '', //验证正则
					validate_str: '', //验证错误提示语
					typeremark: '', //提示文字
					attrvalue: '', //默认值
					attrrow: '', //文本高度
					issearch: 0 ,//加入搜索条件,默认关闭
					lockin:1
				};
			} else {
				console.log(scope);
				this.attrScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname){
			this.$refs[formname].validate((valid,attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!',attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/addModelAttr',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							attr: this.attrScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.getBbsAttrList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		}
	}
};
</script>
<style>
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-table__body-wrapper tbody {
	user-select: none;
}
.el-dialog {
	margin-top: 10vh !important;
}
</style>
